import axios from "axios";

const rolecatalogAPI = axios.create();

rolecatalogAPI.interceptors.request.use((config) => {
  config.headers!.AUTHORIZATION = `Bearer ${sessionStorage.getItem('REDIRECT::INFO') || new URLSearchParams(window.location.search).get('token') || ''}`;
  config.headers!.LANG = localStorage.getItem("LANGUAGE") || "";
  return config;
});

export default rolecatalogAPI;